import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid2";
import Link from "@mui/material/Link";
import { observer } from "mobx-react-lite";
import React, { FormEvent, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { FetchStatusEnum, FetchStatusStrings } from "../../enums/fetchStatusEnum";
import { ResetPasswordEmailRequestSchema } from "../../api/schemas/requests/auth";
import { API } from "../../api/api";
import EmailInput from "../../components/inputs/EmailInput";
import i18nStore from "../../i18n/store";
import { validateEmailFormat } from "../../utils/validateEmail";
import { loginPath } from "../../routes/paths";

const ForgotPasswordForm = observer(() => {
    /*
     * Форма отправки email для сброса пароля.
     * */
    const translations = i18nStore.getTranslations;
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("");

    const [actionStatus, setActionStatus] = useState<FetchStatusStrings>(FetchStatusEnum.IDLE);

    function onInputResetEmail(event: FormEvent) {
        event.preventDefault();

        setActionStatus(FetchStatusEnum.FETCHING);
        const resetData: ResetPasswordEmailRequestSchema = {
            email: email,
        };

        API.auth
            .sendResetPswEmail(resetData)
            .then(() => {
                setActionStatus(FetchStatusEnum.SUCCESS);
            })
            .catch(() => {
                setActionStatus(FetchStatusEnum.ERROR);
            });
    }

    return (
        <>
            <Container component="main" maxWidth="xs" sx={{ p: { xs: 0, md: 2, lg: 3} }}>
                <CssBaseline />
                <Card
                    sx={{
                        p: { xs: 1, md: 2, lg: 3},
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Typography>
                        {translations.forgotPasswordFormTitle}
                    </Typography>

                    <EmailInput email={email} setEmail={setEmail} />

                    {actionStatus === FetchStatusEnum.SUCCESS && (
                        <>
                            <Typography>
                                На Вашу почту
                                <Typography variant="body1" sx={{ fontWeight: "bold" }} component="span">
                                    {` ${email} `}
                                </Typography>
                                в течении нескольких минут придет письмо.
                            </Typography>
                            <Typography>{translations.followInstructionsInEmail}</Typography>
                        </>
                    )}

                    {
                        actionStatus !== FetchStatusEnum.ERROR && actionStatus !== FetchStatusEnum.SUCCESS &&
                        <LoadingButton
                            disabled={
                                !Boolean(email) || !validateEmailFormat(email) || actionStatus !== FetchStatusEnum.IDLE
                            }
                            loading={actionStatus === FetchStatusEnum.FETCHING}
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            onClick={onInputResetEmail}
                        >
                            {translations.continue}
                        </LoadingButton>
                    }

                    <Grid container sx={{ justifyContent: "flex-start"}}>
                        <Grid>
                            <Link
                                href={loginPath}
                                variant="body1"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    navigate(loginPath);
                                }}
                            >
                                {translations.goBack}
                            </Link>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </>
    );
});


export default ForgotPasswordForm;
